import { render, staticRenderFns } from "./show-detail-tabbar.vue?vue&type=template&id=2731a180&scoped=true&"
import script from "./show-detail-tabbar.vue?vue&type=script&lang=js&"
export * from "./show-detail-tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2731a180",
  null
  
)

export default component.exports